import { render } from "./Slider2.vue?vue&type=template&id=30d8c7b0&scoped=true"
import script from "./Slider2.vue?vue&type=script&lang=js"
export * from "./Slider2.vue?vue&type=script&lang=js"

import "./Slider2.vue?vue&type=style&index=0&id=30d8c7b0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d8c7b0"]])

export default __exports__